export default class PersoonGeslachtModel {

    constructor(geslachtAanduiding: string){
        this.aanduiding = geslachtAanduiding;
    }
    public aanduiding: string;
}
